/**
 * Providers page
 *
 * created by Ty D'Angelo 10/17/2022
 */

import * as React from "react";
import { useState, useEffect } from "react";
import { getCookie } from "../utils/cookies";
import axios from "axios";
import ViewProviders from "../providers/view/ViewProviders";
import { CenteredContainer } from "../ui/BaseComponents";

export default function Providers() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const JWT = await getCookie("ea1-auth");
      const { data } = await axios(
        "https://ea1-dev.azurewebsites.net/api/userServiceProviderApprovals?approved=true",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: JWT,
          },
        }
      );
      setData(data);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      alert("error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CenteredContainer>
      <ViewProviders data={data} isLoading={isLoading} />
    </CenteredContainer>
  );
}
